// Canonical dietary tags — kept in sync with backend /api/dietary-legend
export const DIETARY = [
  { code: "vegan",       short: "VG",   label: "Vegan",            color: "#5A7247" },
  { code: "vegetarian",  short: "V",    label: "Vegetarian",       color: "#5A7247" },
  { code: "pescatarian", short: "P",    label: "Pescatarian",      color: "#1E6091" },
  { code: "gluten_free", short: "GF",   label: "Gluten-free",      color: "#8A5A00" },
  { code: "celiac",      short: "C",    label: "Celiac-safe",      color: "#7A4500" },
  { code: "dairy_free",  short: "DF",   label: "Dairy-free",       color: "#0E7490" },
  { code: "nuts",        short: "N",    label: "Contains nuts",    color: "#B91C1C" },
  { code: "diabetic",    short: "D",    label: "Diabetic-friendly",color: "#6D28D9" },
  { code: "halal",       short: "H",    label: "Halal",            color: "#047857" },
  { code: "kosher",      short: "K",    label: "Kosher",           color: "#4338CA" },
  { code: "keto",        short: "KETO", label: "Keto",             color: "#C2410C" },
  { code: "low_carb",    short: "LC",   label: "Low-carb",         color: "#65A30D" },
  { code: "spicy",       short: "SP",   label: "Spicy",            color: "#E11D48" },
];

export const DIETARY_BY_CODE = Object.fromEntries(DIETARY.map((d) => [d.code, d]));

export function normalizeTag(t) {
  // Tolerate older hyphenated variants
  const v = String(t || "").toLowerCase().replace(/-/g, "_");
  return v;
}

export function applicableDietary(tags, legend = DIETARY) {
  const set = new Set((tags || []).map(normalizeTag));
  return legend.filter((d) => set.has(d.code));
}

export function formatKcal(n) {
  if (n == null) return "";
  return `${Math.round(Number(n) || 0)} kcal`;
}
